// RTK Query tag types and IDs for strategy API
export const STRATEGY_TAG_TYPES = {
  STRATEGY: 'Strategy',
  PLAYS: 'PLAYS',
} as const;

export const STRATEGY_TAG_IDS = {
  ALL_STRATEGIES: 'ALL_STRATEGIES',
  USER_STRATEGIES: 'USER_STRATEGIES',
  LIST_MEMBERS: 'LIST_MEMBERS',
  MAP_MEMBERS: 'MAP_MEMBERS',
  TERRITORIES: 'TERRITORIES',
  PLAYS: 'PLAYS',
} as const;

// Export individual constants for easier use with 'as const'
export const STRATEGY_TAG_TYPE = 'Strategy' as const;
export const STRATEGY_METRIC_TYPE = 'STRATEGY_METRICS' as const;
export const ALL_STRATEGIES_ID = 'ALL_STRATEGIES' as const;
export const USER_STRATEGIES_ID = 'USER_STRATEGIES' as const;
export const MY_CHAINED_STRATEGIES_ID = 'MY_CHAINED_STRATEGIES' as const;
export const MAP_MEMBERS_ID = 'MAP_MEMBERS' as const;
export const ENGAGE_MAP_MEMBERS_ID = 'ENGAGE_MAP_MEMBERS' as const;
export const LIST_MEMBERS_ID = 'LIST_MEMBERS' as const;
export const ENGAGE_LIST_MEMBERS_ID = 'ENGAGE_LIST_MEMBERS' as const;
export const TERRITORIES_ID = 'TERRITORIES' as const;
export const PLAYS_ID = 'PLAYS' as const;
export const ALL_STRATEGIES_MAP_ID = 'ALL_STRATEGIES_MAP' as const;
export const ALL_STRATEGIES_MEMBERS_ID = 'ALL_STRATEGIES_MEMBERS' as const;

/**
 * Shared invalidation tags for all strategy member views (list + map,
 * target + engage + all-strategies). Use this array when a mutation
 * changes data that should refresh every strategy member cache.
 */
export const ALL_STRATEGY_MEMBER_TAGS = [
  { type: STRATEGY_TAG_TYPE, id: ALL_STRATEGIES_MEMBERS_ID },
  { type: STRATEGY_TAG_TYPE, id: ALL_STRATEGIES_MAP_ID },
  { type: STRATEGY_TAG_TYPE, id: MAP_MEMBERS_ID },
  { type: STRATEGY_TAG_TYPE, id: LIST_MEMBERS_ID },
  { type: STRATEGY_TAG_TYPE, id: ENGAGE_MAP_MEMBERS_ID },
  { type: STRATEGY_TAG_TYPE, id: ENGAGE_LIST_MEMBERS_ID },
] as const;
